<template>
  <jt-card-default
    :shouldShowSelectMonth="true"
    :cardSelectType="0"
    @change="onChangeSelectBar"
  >
    <div v-if="isLoadingBar" class="div-loader">
      <div class="spinning-loader rotate"></div>
    </div>
    <jt-bar-chart
      v-else
      centralTitleConst="DASHBOARD_BILLING_AVG_RESIDUE_VEHICLE_PER_HOUR"
      class="editCss"
      :data="collectionsSpecialComunData"
      :xAxisData="collectionsSpecialComunColumn"
      :shouldShowOverlappingBars="false"
      :yAxisIndexNames="[this.$gettext('DASHBOARD_RECEIPT_TONNE'), this.$gettext('DASHBOARD_RECEIPT_VEHICLE')]"
    />
  </jt-card-default>
</template>

<script>
import JtBarChart from 'src/components/charts/JtBarChart.vue'
import JtCardDefault from 'src/components/dashboard/dashboard-card-components/base/JtCardDefault.vue'
import { Component, Vue } from 'vue-property-decorator'
import { repository } from 'jtech'
import moment from 'moment'

@Component({
  name: 'AvgResidueVehiclePerHour',
  components: {
    JtCardDefault,
    JtBarChart
  }
})
export default class AvgResidueVehiclePerHour extends Vue {
  isLoadingBar = false;

  currentDate = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1
  };

  doughnutData = [];
  collectionsSpecialComunColumn = [];
  collectionsSpecialComunData = [];

  async onChangeSelectBar (date) {
    this.isLoadingBar = true

    this.doughnutData = await this.getDoughnutData(date)

    const daysInMonth = moment().month(date.month - 1).daysInMonth()

    this.collectionsSpecialComunData = [
      {
        data: this.doughnutData.map((register) => parseInt(parseInt(register.residue.replaceAll('.', '')) / 1000 / daysInMonth)),
        name: this.$gettext('DASHBOARD_BILLING_RESIDUE_PER_HOUR'),
        type: 'bar',
        yAxisIndex: 0
      },
      {
        data: this.doughnutData.map((register) => (parseInt(register.vehicle / daysInMonth) == 0 && parseInt(parseInt(register.residue.replaceAll('.', '')) / 1000 / daysInMonth) != 0) ? 1 : parseInt(register.vehicle / daysInMonth)),
        name: this.$gettext('DASHBOARD_BILLING_VEHICLE_PER_HOUR'),
        type: 'line',
        yAxisIndex: 1
      }

    ]

    this.collectionsSpecialComunColumn = this.doughnutData.map(
      (register) => register.hour
    )

    setTimeout(() => {
      this.isLoadingBar = false
    }, 500)
  }

  async created () {
    await this.onChangeSelectBar(this.currentDate)
  }

  async getDoughnutData (date) {
    const { registros } = await repository.resolveDatatableModel(
      'entrance.hql',
      {
        grid: 'avgResidueVehiclePerHour',
        month: date.month,
        year: date.year
      }
    )
    return registros
  }
}
</script>

<style lang='stylus' scoped>
@import '~quasar-variables';
</style>
